import localforage from 'localforage'

localforage.config({
  name: 'ExperimentsDB',
  storeName: 'exp_images',
})

// Convert Blob to Base64
function blobToBase64(blob) {
  return new Promise(resolve => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result)
    reader.readAsDataURL(blob)
  })
}

// Extract real image key (middle part)
function getStableKey(url) {
  try {
    const parts = url.split('/')
    const fileName = parts[parts.length - 2] // stable part
    return fileName // exp_img_<filename>
  } catch (e) {
    return url
  }
}

export async function getCachedImage(url) {
  const key = getStableKey(url)

  // Check IndexedDB
  const cached = await localforage.getItem(key)
  if (cached) return cached

  // Download and cache
  try {
    const res = await fetch(url, { cache: 'force-cache' })
    const blob = await res.blob()
    const base64 = await blobToBase64(blob)

    await localforage.setItem(key, base64)
    return base64
  } catch (e) {
    console.warn('image load error', e)
    return url
  }
}
